{% block prems_discount_customer_group_selector_content %}
    <div class="sw-condition-line-item-in-category sw-condition__condition-value">
        <sw-entity-multi-select
            :label="$tc('prems-discount-category.detail.card.customerRestriction.field.customerGroupLabel')"
            :placeholder="$tc('prems-discount-category.detail.card.customerRestriction.field.customerGroupPlaceholder')"
            size="medium"
            entity="customer_group"
            :entityCollection="customerGroups"
            @update:entity-collection="setCustomerGroupIds"
        >
        </sw-entity-multi-select>
    </div>
{% endblock %}